// React
import React, { useState } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
// Microsoft
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import * as microsoftTeams from '@microsoft/teams-js';
// Styling
import { Warning } from '@phosphor-icons/react';
import { ActivateSubAlertContainer, ActivateSubAlertContent } from './styles';
import { useTranslation } from 'react-i18next';
import { callCommerceFunction } from '../../lib/Helpers';
import { toast } from 'react-toastify';
import { Spinner, SpinnerSize } from '@fluentui/react';

interface ActivateSubAlertProps {
  subid: string;
  planid: string;
  quantity: string;
}

export const ActivateSubAlert = ({
  subid,
  planid,
  quantity
}: ActivateSubAlertProps) => {
  
  const appInsights = useAppInsightsContext();
  microsoftTeams.app.initialize();

  const { t } = useTranslation('alerts');

  const [isActivating, setIsActivating] = useState(false);

  function activateSubscription(
  ) {
    setIsActivating(true);
    callCommerceFunction(
      true,
      'activateSubscription?{0}&subid=' +
      subid +
      '&planid=' +
      planid +
      '&quantity=' +
      quantity
    )
      .catch((error) => {
        toast.error(t('SUBSCRIPTIONS_ACTIVATION_ERROR'));
        if (appInsights)
          appInsights.trackException({
            exception: error,
            properties: {
              component: 'App',
              location: 'onActivateSubscription',
            },
          });
      })
      .then(() => {
        toast.success(t('SUBSCRIPTIONS_ACTIVATION_SUCCESS'));
        window.location.reload();
      })
      .finally(() => {
        setIsActivating(false);
      });
  }

  return (
    <ActivateSubAlertContainer>
      <BrowserView>
        <ActivateSubAlertContent>
          <Warning size={32} weight="duotone" />
          <div className="text">
            <h1>{t('ACTIVATE_ALERT_TITLE')}</h1>
            <h2>{t('ACTIVATE_ALERT_SUBTITLE')}</h2>
          </div>
          <button
            disabled={isActivating}
            id="upgradeButton"
            onClick={() => {
              appInsights.trackEvent({
                name: 'Activate Clicked',
                properties: {
                  subsName: subid,
                },
              });
              activateSubscription();
            }}
          >
            {isActivating && <Spinner size={SpinnerSize.small} />}
            {isActivating ? t('PLAN_IS_ACTIVATING') : t('PLAN_ACTIVATE')}
          </button>
        </ActivateSubAlertContent>
      </BrowserView>
      <MobileView>
        <ActivateSubAlertContent>
          <Warning size={32} weight="duotone" />
          <div className="text">
            <h1>{t('ACTIVATE_ALERT_TITLE')}</h1>
          </div>
        </ActivateSubAlertContent>
      </MobileView>
    </ActivateSubAlertContainer>
  );
}
